import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockOurEngagementsGraphql',
  props: {
    title: {
      type: String,
      default: ''
    },
    testimonial: {
      type: String,
      default: ''
    },
    cardsCollection: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers;
    var cards = computed(function () {
      var _props$cardsCollectio;
      return ((_props$cardsCollectio = props.cardsCollection) === null || _props$cardsCollectio === void 0 ? void 0 : _props$cardsCollectio.items) || [];
    });
    var mainCard = computed(function () {
      return cards.value[0];
    });
    var sideCards = computed(function () {
      return cards.value.slice(1, 3);
    });
    var gmtTitleBlockEventClick = computed(function () {
      return "branding_block_click_card_".concat(props.title.replace(/ /g, '_'));
    });
    var gmtTitleBlockEventView = computed(function () {
      return "branding_block_view_".concat(props.title.replace(/ /g, '_'));
    });

    /**
     * Handles the click event on a card and emits a GTM event.
     * @param {Object} card - The card that was clicked.
     * @param {number} index - The index of the card.
     */
    function handleCardClick(card, index) {
      $trackers.gtm.pushEvent('branding_block_click', {
        event: gmtTitleBlockEventClick.value,
        event_action: 'click',
        event_label: card.title,
        position: index + 1,
        page_target: card.externalLinkUrl
      });
    }
    onMounted(function () {
      cards.value.forEach(function (card, index) {
        $trackers.gtm.pushEvent('branding_block_view', {
          event: gmtTitleBlockEventView.value,
          event_action: 'view',
          event_label: card.title,
          position: index + 1,
          page_target: card.externalLinkUrl
        });
      });
    });
    return {
      __sfc: true,
      props: props,
      $trackers: $trackers,
      cards: cards,
      mainCard: mainCard,
      sideCards: sideCards,
      gmtTitleBlockEventClick: gmtTitleBlockEventClick,
      gmtTitleBlockEventView: gmtTitleBlockEventView,
      handleCardClick: handleCardClick,
      AzIcon: AzIcon,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});